import CampaignDetailsLoader from './CampaignDetailsLoader';
export default CampaignDetailsLoader;
